import MKTypography from "../../../components/MKTypography";
import MKBox from "../../../components/MKBox";

import logoPilzerei from "assets/images/Pilzerei_Logo_R-black.png";
import {Link} from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Container from "@mui/material/Container";

function Pilzerei() {
    return (
        <MKBox
            component="section"
            display="grid"
            position="relative"
            minHeight="10vh"
            borderRadius="xl"
            mr={{ xs: 0, lg: -2 }}
            mb={{ xs: 1, lg: 1 }}
            mt={1.5}
            pt={{ xs: 1, lg: 0 }}
            pb={2}
            sx={{ overflow: { xs: "hidden", lg: "visible" }, placeItems: "center" }}
        >
            <Container>
                <Grid container spacing={{ xs: 0, lg: 3 }} sx={{  }}>
                    <Grid size={{xs: 12, lg: 12}} justifyContent="center" flexDirection="column">
                        <MKBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="column"
                            shadow="lg"
                            borderRadius="xl"
                            sx={{
                                backgroundColor: ({ functions: { rgba }, palette: { white } }) =>
                                    rgba(white.main, 0.8),
                                backdropFilter: "saturate(200%) blur(30px)",
                                px: { xs: 3, sm: 6 },
                                py: { xs: 3, sm: 8 },
                                mb: { xs: 0, lg: 8 },
                                mt: { xs: 0, lg: -6 },
                            }}
                        >
                            <Link
                                to="https://pilzerei.ch"
                                href="https://pilzerei.ch"  // External URL
                                target="_blank"                 // Opens in new tab
                                underline="none"                 // Remove default underline
                            >
                                <MKBox
                                    component="img"
                                    src={logoPilzerei}
                                    alt="Pilzerei"
                                    px={{ xs: 3, md: 12, lg: 8, xl: 8 }}
                                    sx={{
                                        width: "100%",             // Adjust size as needed
                                    }}
                                />
                            </Link>

                            <MKBox py={2} px={{ xs: 3, md: 12, lg: 8, xl: 8 }}>
                                <MKTypography component="div" variant="body1" color="text" pb={1}>
                                    <Link
                                        to="https://pilzerei.ch"
                                        href="https://pilzerei.ch"  // External URL
                                        target="_blank"                 // Opens in new tab
                                                        // Remove default underline
                                    >Pilzerei</Link> ist unser liebevoll gewählter Markenname – ein Name, der neugierig macht und gleich verrät, worum es geht. Unter diesem Label bieten wir frische Edelpilze und sorgfältig hergestellte Pilzprodukte an, die Genuss, Qualität und natürliche Vielfalt vereinen.
                                </MKTypography>
                            </MKBox>
                        </MKBox>

                    </Grid>
                </Grid>
            </Container>

        </MKBox>
    )
}

export default Pilzerei